import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GuestServiceMapComponent } from './guest-service-map.component';
import { ComponentHeaderModule } from '@finder/shared/components/component-header/component-header.module';
import { MapModule } from '@finder/shared/components/map/map.module';
import { AccordionModule } from '@finder/shared/components/accordion/accordion.module';

@NgModule({
    imports: [
        CommonModule,
        MapModule,
        ComponentHeaderModule,
        AccordionModule
    ],
    declarations: [
        GuestServiceMapComponent
    ],
    exports: [
        GuestServiceMapComponent
    ]
})
export class GuestServiceMapModule {
    static entry = GuestServiceMapComponent;
}
